import { IPluginEnroll } from "./base/pluginModels";
import { isPluginEnrollInterface } from "./decodePluginMsg";
import { IPluginCameraImage } from "./base/cameraModels";

export const decodeCameraPluginMsg = (obj) => {
    let imageCapture = {} as IPluginCameraImage;

    if (isPluginEnrollInterface(obj)) {
        let jsonObj = {} as IPluginEnroll;

        if (typeof obj === "string") {
            jsonObj = JSON.parse(obj);
        }

        var pluginType = jsonObj.enrollType;

        if (pluginType == "camera") {
            var base64 = "";
            var images = jsonObj.enrollData.split(";");
            var image1 = images[0];
            var image1Details = image1.split(":");
            var image1base64 = image1Details[0].split("=");
            if (image1base64[1] != '0') {
                base64 = 'data:image/jpg;base64,' + image1base64[1];
            }
            imageCapture.image = base64;
            imageCapture.enrollType = pluginType;
            return imageCapture;
        }
    }
    return imageCapture;
};